import { Phone, Stethoscope, ShieldCheck, AlertTriangle } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import type { PetFormData } from "@/pages/CadastrarPet";

interface Props {
  formData: PetFormData;
  updateField: <K extends keyof PetFormData>(field: K, value: PetFormData[K]) => void;
}

const Emergencia = ({ formData, updateField }: Props) => {
  return (
    <div className="space-y-6">
      <div className="text-center mb-2">
        <div
          className="inline-flex items-center justify-center w-16 h-16 rounded-full gradient-coral mb-4"
          style={{ boxShadow: "var(--shadow-3d-coral)" }}
        >
          <AlertTriangle className="w-8 h-8 text-primary-foreground" />
        </div>
        <h2 className="text-2xl font-extrabold text-foreground">Emergência</h2>
        <p className="text-muted-foreground mt-2">
          Informações importantes para situações de emergência do seu pet.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="p-4 rounded-xl bg-muted/30 border border-border space-y-3">
          <div className="flex items-center gap-2 text-coral font-bold text-sm">
            <Phone className="w-4 h-4" />
            Contato de Emergência
          </div>

          <div>
            <Label htmlFor="emergencia" className="text-xs font-semibold">
              Nome e telefone
            </Label>
            <Input
              id="emergencia"
              value={formData.emergencia}
              onChange={(e) => updateField("emergencia", e.target.value)}
              placeholder="Ex: Maria - (44) 99999-9999"
              className="mt-1"
            />
          </div>
        </div>

        <div className="p-4 rounded-xl bg-muted/30 border border-border space-y-3">
          <div className="flex items-center gap-2 text-forest font-bold text-sm">
            <Stethoscope className="w-4 h-4" />
            Veterinário
          </div>

          <div>
            <Label htmlFor="contato_medico_vet" className="text-xs font-semibold">
              Nome e telefone
            </Label>
            <Input
              id="contato_medico_vet"
              value={formData.contato_medico_vet}
              onChange={(e) => updateField("contato_medico_vet", e.target.value)}
              placeholder="Ex: Dr. João - (44) 98888-8888"
              className="mt-1"
            />
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="flex items-center justify-between p-4 rounded-xl bg-muted/50 border border-border">
          <Label htmlFor="autoriza_vet" className="text-sm font-semibold cursor-pointer">
            Autoriza atendimento veterinário?
          </Label>
          <Switch
            id="autoriza_vet"
            checked={formData.autoriza_vet}
            onCheckedChange={(v) => updateField("autoriza_vet", v)}
          />
        </div>

        <div className="flex items-center justify-between p-4 rounded-xl bg-muted/50 border border-border">
          <Label htmlFor="autoriza_plantao" className="text-sm font-semibold cursor-pointer">
            Autoriza plantão?
          </Label>
          <Switch
            id="autoriza_plantao"
            checked={formData.autoriza_plantao}
            onCheckedChange={(v) => updateField("autoriza_plantao", v)}
          />
        </div>
      </div>
    </div>
  );
};

export default Emergencia;